import { NumberMaskProcessing } from './number';

export class IntMaskProcessing extends NumberMaskProcessing {
  protected fixedDecimals = 0;
}
